module.exports = __webpack_public_path__ + "static/media/flshlight.c988e0c3.svg";